export default "__VITE_ASSET__O_4nS$DS__"